import { ElementRef, Injectable, Renderer2 } from '@angular/core';

import { EqualizeParams } from '../equalize-params';

@Injectable()
export class EqualizerService {
    public equalize(
        renderer: Renderer2,
        elementRefs: ElementRef[],
        params: EqualizeParams = {property: 'height', reset: true}
    ) {

        let maxValue: number = 0;

        elementRefs.map(
            (elementRef: ElementRef) => {
                if (params.reset) {
                    renderer.setStyle(elementRef.nativeElement, params.property, 'initial');
                }

                const value: number = elementRef.nativeElement['offset' + params.property[0].toUpperCase() + params.property.slice(1)];
                maxValue = value > maxValue ? value : maxValue;
            }
        );

        elementRefs.map(
            (elementRef: ElementRef) => {
                renderer.setStyle(elementRef.nativeElement, params.property, maxValue + 'px');
            }
        );
    }
}
